//ie用ポリフィル
import "es6-promise/auto";
import "fetch-polyfill";
//-----------------------

import firebase from "firebase/app";
import "firebase/database";
import Chart from "chart.js";

import ScrollMagic from "scrollmagic";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js";

const controller = new ScrollMagic.Controller();

function init(urls) {
  return new Promise((resolve, reject) => {
    // 宣言
    let request = new XMLHttpRequest();

    // リクエストURLを設定（リクエストタイプはPOSTにすること）
    request.open("POST", urls);

    // リクエスト先からレスポンス（返答）があった場合の処理
    request.onreadystatechange = function () {
      if (request.readyState == 4 && request.status == 200) {
        // 処理
        resolve(request.responseText);
      }
    };
    request.send();
  });
}

init("./api/1qd3x3ap1h.php").then((url) => {
  //Firebaseの初期化
  firebase.initializeApp({
    databaseURL: url,
  });

  // const scene_usersVoice = new ScrollMagic.Scene({
  //   triggerElement: ".top-usersVoice",
  //   triggerHook: 'onCenter',
  //   // duration: 800,
  //   offset: -360
  // })
  //   // .addIndicators()
  //   .addTo(controller);

  // let usersVoiceFlug = false;

  // scene_usersVoice.on('enter', () => {
  //   if (usersVoiceFlug) return

  //   new Graph("js-usersVoice-graph-01", {
  //     backgroundColor: [
  //       "#105DE1",
  //       "#F1F4F8",
  //       "#F1F4F8"
  //     ],
  //     data: [
  //       "about_expectation",
  //       "about_not_expectation",
  //       "about_not_know"
  //     ]
  //   });

  //   new Graph("js-usersVoice-graph-02", {
  //     backgroundColor: [
  //       "#F1F4F8",
  //       "#0E4598",
  //       "#F1F4F8"
  //     ],
  //     data: [
  //       "about_expectation",
  //       "about_not_expectation",
  //       "about_not_know"
  //     ]
  //   });

  //   new Graph("js-usersVoice-graph-03", {
  //     backgroundColor: [
  //       "#F1F4F8",
  //       "#F1F4F8",
  //       "#0E4598"
  //     ],
  //     data: [
  //       "about_expectation",
  //       "about_not_expectation",
  //       "about_not_know"
  //     ]
  //   });

  //   usersVoiceFlug = true;
  // });

  const scene_graph01 = new ScrollMagic.Scene({
    triggerElement: "#js-graph-01",
    triggerHook: "onCenter",
    // duration: 800,
    offset: 0,
  })
    // .addIndicators()
    .addTo(controller);

  let graph01 = false;

  scene_graph01.on("enter", () => {
    if (graph01) return;
    graph01 = true;
    new Graph("js-graph-01", {
      backgroundColor: ["#105DE1", "#0E4598", "#012262", "#8B90A0", "#D1D1D1"],
      data: [
        "expectation_shopping",
        "expectation_work",
        "expectation_employment",
        "expectation_entry",
        "expectation_foreigner",
      ],
    });
    document.querySelector("#js-graph-01").classList.add("is-draw-graph");
  });

  const scene_graph02 = new ScrollMagic.Scene({
    triggerElement: "#js-graph-02",
    triggerHook: "onCenter",
    // duration: 800,
    offset: 0,
  })
    // .addIndicators()
    .addTo(controller);

  let graph02 = false;

  scene_graph02.on("enter", () => {
    if (graph02) return;
    graph02 = true;
    new Graph("js-graph-02", {
      backgroundColor: ["#105DE1", "#0E4598", "#012262", "#8B90A0", "#D1D1D1"],
      data: [
        "know_rebuilding",
        "know_newentry",
        "know_after_COVID",
        "know_shopping",
        "know_vacancy",
      ],
    });
    document.querySelector("#js-graph-02").classList.add("is-draw-graph");
  });
});

class Graph {
  constructor(target, options) {
    this.rootElement = document.getElementById(target);
    if (!this.rootElement) return;

    this.db = firebase.database();
    this.ref = this.db.ref("tenjin-bigbang");

    this.count = {
      about_expectation: 0, //期待している
      about_not_expectation: 0, //あまり期待はない
      about_not_know: 0, //内容を知らない
      expectation_shopping: 0, //買い物がしやすくなる
      expectation_work: 0, //仕事がしやすくなる
      expectation_employment: 0, //雇用が増える
      expectation_entry: 0, //新しい産業や企業が参入する
      expectation_foreigner: 0, //仕事や観光で外国人が増える
      know_rebuilding: 0,
      know_newentry: 0,
      know_after_COVID: 0,
      know_shopping: 0,
      know_vacancy: 0,
      like_tenjin: 0, //天神
      like_hakata: 0, //博多
      like_both: 0, //両方
      like_not_both: 0, //どちらも好きではない
      good_city: 0, //首都圏などのような大都市
      good_shopping_work: 0, //今ぐらいの規模で、買い物も仕事もしやすい街
      good_friendly: 0, //若者が集い、高年齢層にも優しい街
      good_international: 0, //金融機能の集積などによる国際都市
      good_latest: 0, //最先端の「もの」に出会える街
    };

    this.countRatio = {};

    this.chartOpotions = options;

    this.chartDatasets = this.chartOpotions.data;
    this.chartTarget = this.rootElement.querySelector(`.js-graph`);
    this.chartSettings = this.createChartSettings(
      this.getChartDatasetsValue(this.chartDatasets)
    );
    this.chart = "";

    // this.count = this.mergedOptions(this.count, options)
    this.radioButtons = [
      ...this.rootElement.querySelectorAll(".c-ui-form-radio"),
    ];

    this.createChart();
    this.getValue();
    this.upDateValue();

    this.clickEvent = this.registerClickEvent();
  }

  mergedCount(currentCount, options) {
    const mergedCount = Object.assign(currentCount, options || {});

    return mergedCount;
  }

  getValue() {
    this.ref.on("child_added", (snapshot) => {
      let obj = {
        [snapshot.key]: snapshot.val(),
      };
      this.mergedCount(this.count, obj);
      this.updateChart();
      this.setCountRatio();
      this.renderRatio();
    });
  }

  upDateValue() {
    this.ref.on("value", (snapshot) => {
      this.mergedCount(this.count, snapshot.val());
      this.updateChart();
      this.setCountRatio();
      this.renderRatio();
    });
  }

  createChart() {
    // console.log(this.count.facebook)
    this.chart = new Chart(this.chartTarget, this.chartSettings);
  }

  getChartDatasetsValue(chartDatasets) {
    let items = chartDatasets;
    const result = items.map((value, index, array) => {
      return this.count[value];
    });

    return result;
  }

  createChartSettings(datasets) {
    const chartSettings = {
      type: "doughnut",
      data: {
        labels: ["期待している", "あまり期待していない", "内容を知らない"],
        datasets: [
          {
            backgroundColor: this.chartOpotions.backgroundColor,
            data: this.chartOpotions.data,
          },
        ],
      },
      options: {
        title: {
          display: false,
          text: "天神ビッグバンについて",
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        hover: {
          mode: null,
        },
        cutoutPercentage: 74,
      },
    };

    return chartSettings;
  }

  updateChart() {
    const datasets = this.getChartDatasetsValue(this.chartDatasets);
    this.chart.data.datasets[0].data = datasets;
    this.chart.update();
  }

  setCountRatio() {
    const countValue = this.getChartDatasetsValue(this.chartDatasets);

    const total = countValue.reduce(
      (accumulator, currentValue, currentIndex, array) => {
        return accumulator + currentValue;
      }
    );

    let ratioObj = {};

    //レートを配列に格納
    let ratio = countValue.map((v, i) => {
      return parseInt((v / total) * 100);
    });
    //レートの合計値
    let ratioTotal = ratio.reduce(
      (accumulator, currentValue, currentIndex, array) => {
        return accumulator + currentValue;
      }
    );

    //レートの合計値が100未満の場合はその差分を一番高い値にプラス
    if (ratioTotal < 100) {
      let max = ratio.reduce(
        (accumulator, currentValue, currentIndex, array) => {
          return Math.max(accumulator, currentValue);
        }
      );
      ratio[ratio.indexOf(max)] =
        ratio[ratio.indexOf(max)] + (100 - ratioTotal);
    }

    ratio.map((v, i) => {
      // console.log(isNaN(v) + v)
      let ratio = isNaN(v) ? 0 : v;
      let obj = {
        [this.chartDatasets[i]]: ratio,
      };
      ratioObj = Object.assign(ratioObj, obj || {});
    });

    this.countRatio = Object.assign(this.countRatio, ratioObj || {});

    // console.log(this.countRatio)
  }

  renderRatio() {
    this.chartDatasets.forEach((v) => {
      const target = this.rootElement.querySelector(`.js-ratio-${v}`);
      if (!target) return;
      target.textContent = this.countRatio[v];
    });
  }

  registerClickEvent() {
    let register = [];
    this.radioButtons.forEach((target, index) => {
      register.push(
        this.attachEvent(target, "click", this.postCount.bind(this, target))
      );
      register[index].addEvent();
    });
    return register;
  }

  postCount(target, event) {
    //二重イベント対策
    if (!(event.target.tagName == "INPUT")) return;

    let value = event.currentTarget
      .querySelector("input")
      .getAttribute("value");
    let obj = {
      [value]: this.count[value] + 1,
    };

    this.ref.update(obj);

    this.radioButtons.forEach((radio, index) => {
      radio.querySelector("input").setAttribute("disabled", true);
    });
  }

  attachEvent(element, type, listener, options) {
    return {
      addEvent() {
        element.addEventListener(type, listener, options);
      },
      removeEvent() {
        element.removeEventListener(type, listener);
      },
    };
  }
}

//===============================================

// const database = firebase.database();
// const refCount = database.ref("tenjin-bigbang");

// let countStop = false;
// let $post = $(".button");
// let countObj = {
//   count: 0,
//   facebook: 0,
//   twitter: 0,
//   instagram: 0,
//   tiktok: 0,
//   clubhouse: 0
// };
// let $layer = $(".modal");

// /*
//  * クリックイベント
//  * ・初期読み込み
//  * ・ボタンクリック
//  */
// $post.on("click", function (e) {
//   if (countStop) {
//     return;
//   }
//   let initial = $(e.currentTarget).data("initial");
//   countObj[initial] = countObj[initial] + 1;
//   postActionCount(initial, countObj[initial]);
// });

// refCount.on("child_added", function (snapshot) {
//   // データベースと同期
//   countObj[snapshot.key] = snapshot.val();

//   defRenderCount({
//     id: snapshot.key,
//     value: snapshot.val()
//   });
// });

// refCount.on("value", function (snapshot) {
//   let snapshotObj = snapshot.val();

//   // データベースと同期
//   for (let key in snapshotObj) {
//     countObj[key] = snapshotObj[key];
//   }

//   renderCount(snapshot.val());
// });

// /*
//  * View
//  * ・カウント表示
//  */
// let defRenderCount = function (countObj) {
//   let $targetCountObj = $(".js-count-" + countObj.id);

//   $targetCountObj.text(countObj.value);
// };

// let renderCount = function (countObj) {
//   for (let key in countObj) {
//     if (parseInt($(".js-count-" + key).text(), 10) !== countObj[key]) {
//       let $targetCountObj = $(".js-count-" + key);
//       let $targetCountObjPost = $targetCountObj.closest(".js-post");

//       $targetCountObj.text(countObj[key]);
//     }
//   }
// };

// let postActionCount = function (initial, countVal) {
//   let arg = {};
//   arg[initial] = countVal;
//   refCount.update(arg);
// };
